export const themeOptionFactory = (theme) => ({
  assets: {
    empty: {
      department: {
        icon_path:
          "M21.9206 23.331L20.4602 7.06712C20.4204 6.62296 20.0481 6.28276 19.6022 6.28276H16.5906V4.92446C16.5906 2.393 14.5312 0.333496 11.9998 0.333496C9.4686 0.333496 7.40944 2.393 7.40944 4.92446V6.28276H4.3957C3.94982 6.28276 3.57757 6.62296 3.53771 7.06712L2.07156 23.395C2.04997 23.636 2.1306 23.8748 2.29381 24.0532C2.45702 24.2317 2.68777 24.3334 2.92954 24.3334H21.0685C21.0692 24.3334 21.0701 24.3334 21.0708 24.3334C21.5466 24.3334 21.9322 23.9477 21.9322 23.472C21.9321 23.4241 21.9282 23.3769 21.9206 23.331ZM9.13229 4.92446C9.13229 3.34299 10.4187 2.05635 11.9999 2.05635C13.5813 2.05635 14.8678 3.34299 14.8678 4.92446V6.28276H9.13229V4.92446ZM3.87183 22.6106L5.18327 8.00562H7.40944V9.54608C7.40944 10.0218 7.79501 10.4075 8.27087 10.4075C8.74672 10.4075 9.13229 10.0218 9.13229 9.54608V8.00562H14.8678V9.54608C14.8678 10.0218 15.2534 10.4075 15.7292 10.4075C16.2051 10.4075 16.5907 10.0218 16.5907 9.54608V8.00562H18.8148L20.1262 22.6106H3.87183Z",
      },
    },
  },
  components: {
    EmDepartmentStorePage: {
      styleOverrides: {
        sectionHeader: {
          marginBottom: theme.spacing(2),
        },
        occupantCardsContainer: {
          marginLeft: theme.spacing(-3),
          marginRight: theme.spacing(-3),
          padding: theme.spacing(1, 3),
          position: "relative",
          display: "grid",
          gridTemplateColumns: "auto",
          gap: theme.spacing(2),
          overflowX: "auto",
          "::-webkit-scrollbar": {
            display: "none",
          },
        },
        occupantCardWrapper: {
          width: "100%",
          height: "100px",
        },
        gridContainer: {
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(175px, 1fr))",
          justifyItems: "center",
          gap: theme.spacing(1),
          "@media (max-width: 400px)": {
            gridTemplateColumns: "repeat(auto-fill, minmax(145px, 1fr))",
          },
        },
        emptyDataContainer: {
          height: `calc(100vh - ${
            theme?.mixins?.mobileHeader?.height || 80
          }px - ${theme?.mixins?.bottomNavigation?.height + 30}px - 72px)`,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        departmentImageCard: {
          maxWidth: "180px",
          boxShadow: "0px 8px 24px 0px rgba(155, 155, 155, 0.15)",
          display: "block",
          overflow: "hidden",
          aspectRatio: "1 / 1",
          width: "100%",
          height: "100%",
          "& .MuiCardActionArea-root": {
            width: "100%",
            height: "100%",
            "&:after": {
              display: "none",
            },
          },
          "& .MuiCardHeader-root .MuiCardHeader-title": {
            lineHeight: 1.3,
          },
          "& .MuiCardHeader-title": {
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            color: theme.palette.text.primary,
            fontSize: "min(1.125rem, 3vw)",
            marginTop: theme.spacing(1),
            "&:after": {
              content: "''",
              display: "block",
              width: "70%",
              height: "1px",
              marginTop: theme.spacing(1),
              backgroundColor: theme.palette.primary.main,
            },
          },
          "& .MuiCardHeader-root": {
            height: "30%",
            paddingTop: theme.spacing(0),
            paddingLeft: theme.spacing(1),
            background: theme.palette.common.white,
            alignItems: "flex-start",
            position: "relative",
            "& .location-text": {
              position: "absolute",
              bottom: "8px",
              right: "0px",
              padding: theme.spacing(0.5, 1.25),
              overflow: "hidden",
              background: theme.palette.common.black,
              color: theme.palette.common.white,
              marginLeft: "auto",
              width: "31px",
              height: "25px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderTopLeftRadius: "20px",
              fontSize: "0.75rem",
            },
            "& .MuiCardHeader-content": {
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              justifyContent: "start",
              height: "100%",
              marginBottom: theme.spacing(-0.5),
              marginRight: theme.spacing(-0.5),
            },
          },
          "& .MuiCardMedia-img": {
            width: "100%",
            height: "70%",
            backgroundColor: theme.palette.secondary.main,
          },
        },
      },
    },
    DepartmentStoreOccupantCard: {
      styleOverrides: {
        root: {
          boxShadow: theme.shadows[1],
          display: "flex",
          height: "100%",
          borderRadius: `${(theme.shape.borderRadius * 2) / 3}px`,
          "& .MuiTypography-root": {
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
            overflow: "hidden",
          },
        },
        occupantLogo: {
          boxShadow: theme.shadows[1],
          minWidth: "80px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "& .MuiAvatar-root": {
            borderRadius: "0",
            width: "100%",
            height: "100%",
          },
          "& .MuiAvatar-img": {
            objectFit: "cover",
          },
          "& .MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
          },
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          width: "100%",
          "& .MuiTypography-root": {
            lineHeight: 1.25,
          },
        },
        levelContainer: {
          background: theme.palette.common.black,
          padding: theme.spacing(0.5, 1),
          color: theme.palette.common.white,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "20px 0px 0px 0px",
        },
        venueLogo: {
          width: "100%",
          objectFit: "contain",
        },
        venueLogoContainer: {
          display: "flex",
          alignItems: "center",
          flex: 1,
        },
        titleContainer: {
          flex: "3",
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
        titleText: {
          fontSize: "0.875rem",
          fontWeight: 400,
          textTransform: "capitalize",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
        },
        categoryText: {
          fontSize: "0.625rem",
          fontWeight: 400,
          color: theme.palette.text.secondary,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 1,
          overflow: "hidden",
        },
        occupantIdentityContainer: {
          display: "flex",
          height: "100%",
          padding: theme.spacing(0.5, 0.875, 0),
          gap: theme.spacing(0.875),
          flex: 1.4,
        },
        occupantDetailWrapper: {
          display: "flex",
          flexDirection: "column",
          height: "100%",
          justifyContent: "flex-end",
          flex: "1",
        },
        occupantDetailContainer: {
          height: "100%",
          display: "flex",
          justifyContent: "space-between",
        },
        categoryDetailContainer: {
          display: "flex",
          alignItems: "center",
          paddingLeft: theme.spacing(0.875),
        },
        levelContainerWrapper: {
          height: "100%",
          display: "flex",
          alignItems: "end",
          "& .MuiTypography-root": {
            fontSize: "0.875rem",
          },
        },
      },
    },
  },
})
